import React from "react";
import "./styles.styl";
import classnames from "classnames";

export const GroupItem = ({ image, itemName, itemAmount, editable }) => {
  return (
    <>
      <div className="group-item__main">
        <div
          className={classnames("group-item__contents", {
            "group-item__disabled-item": !editable,
          })}
        >
          <img className={"group-item__image"} src={image} alt="item-image" />
          <span className="group-item__item-name">{itemName}</span>
          <span className="group-item__item-amount">{itemAmount}</span>
        </div>
      </div>
    </>
  );
};
